<template>
  <div class="autocomplete-input">
    <p class="control has-icon has-icon-right">
      <input v-model="keyword" class="input is-large" placeholder="Användarnamn" @input="onInput($event.target.value)" @keyup.esc="isOpen = false" @blur="isOpen = false" @keydown.down="moveDown" @keydown.up="moveUp" @keydown.enter="select">
    </p>
    <ul v-show="isOpen" class="options-list">
      <li v-for="(option, index) in fOptions" :class="{
          'highlighted': index === highlightedPosition
        }" @mouseenter="highlightedPosition = index" @mousedown="select">
        <slot name="item" :title="option">
        </slot>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
    name: 'Autocomplete',
    props: {
        options: {
            type: Array,
            required: true
        },
        value: {
            type: String
        }
    },
    data () {
        return {
            isOpen: false,
            highlightedPosition: 0,
            keyword: ''
        }
    },
    computed: {
        fOptions () {
            const re = new RegExp(this.keyword, 'i')
            return this.options.filter(o => o.match(re))
        }
    },
    methods: {
        onInput (value) {
            this.highlightedPosition = 0
            this.isOpen = !!value
            this.$emit('input', value)
        },
        moveDown () {
            if (!this.isOpen) {
                return
            }
            this.highlightedPosition = (this.highlightedPosition + 1) % this.fOptions.length
        },
        moveUp () {
            if (!this.isOpen) {
                return
            }
            this.highlightedPosition = this.highlightedPosition - 1 < 0 ? this.fOptions.length - 1 : this.highlightedPosition - 1
        },
        select () {
            const selectedOption = this.fOptions[this.highlightedPosition]
            this.$emit('select', selectedOption)
            this.isOpen = false
            this.keyword = selectedOption
        }
    }
}
</script>

<style lang="scss">
.autocomplete-input {
    z-index: 2;
    position: relative;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

ul.options-list {
    display: flex;
    flex-direction: column;
    margin-top: 2.5rem;
    border: 1px solid #dbdbdb;
    border-radius: 0 0 6px 6px;
    position: absolute;
    width: 100%;
    overflow: hidden;
    list-style-type: none;
    padding: 0;
}

ul.options-list li {
    width: 100%;
    flex-wrap: wrap;
    background: white;
    border-bottom: 1px solid #eee;
    color: #363636;
    padding-top: 0.5rem;
    padding-left: 1rem;
    cursor: pointer;
}

ul.options-list li.highlighted {
    background: #f8f8f8
}

.input {
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0.25rem;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;;
    line-height: 1.25;
    padding: 0.6rem 0.91rem;
    font-size: 1rem;
    height: 100%;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
}

.control {
    margin-bottom: 0;
    height: 100%;
    -webkit-box-flex: 1;
}

</style>



// WEBPACK FOOTER //
// src/components/parts/Autocomplete.vue